import { Helmet } from 'react-helmet-async';

export const SEO = ({ title, description, canonical }) => {
  const siteUrl = "https://magiccplumbing.com";
  const defaultDescription = "Magic C Plumbing – reliable plumbing and heating in London SW18 & SW19. Leak repairs, bathrooms, boilers and landlord services. Call 07398 873176.";
  const finalDescription = description || defaultDescription;
  
  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={`${siteUrl}${canonical}`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${siteUrl}${canonical}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={finalDescription} />
    </Helmet>
  );
};
